import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d4c67e2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d4c67e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default,CoursesWhy: require('/opt/build/repo/components/Courses/Why.vue').default,CardsCourseCardsOnline: require('/opt/build/repo/components/Cards/CourseCardsOnline.vue').default,BlocksTextBanner: require('/opt/build/repo/components/Blocks/TextBanner.vue').default,CardsCourseCardsCombined: require('/opt/build/repo/components/Cards/CourseCardsCombined.vue').default,CardsCourseCardsDiploma: require('/opt/build/repo/components/Cards/CourseCardsDiploma.vue').default,CardsCourseCardsAdvanced: require('/opt/build/repo/components/Cards/CourseCardsAdvanced.vue').default,CardsCourseCardsClassroom: require('/opt/build/repo/components/Cards/CourseCardsClassroom.vue').default,BlocksFaq: require('/opt/build/repo/components/Blocks/Faq.vue').default,CoursesFAQ: require('/opt/build/repo/components/Courses/FAQ.vue').default})
